import React from 'react';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import QueryHandler from 'src/components/10-atoms/QueryHandler';
import Column from 'src/components/10-atoms/layout/Column';
import LoaderBase from 'src/components/10-atoms/loaders/LoaderBase';
import Typography from 'src/components/10-atoms/typography/Typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import QuestionItem from 'src/modules/exam-preparation/containers/QuestionList/QuestionItem';
import ImproveQuestion from './ImproveQuestion';
// RNW maps role="region" to <section>.
const visuallyHidden = {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
};
const QuestionQueryHandler = ({ question, questionString, queryState, onRetry, onEditPress, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const questionDetails = queryState.data?.ep_questionDetails || question;
    return (React.createElement(QueryHandler, { queryState: {
            ...queryState,
            data: questionDetails
                ? { ep_questionDetails: questionDetails }
                : undefined,
        }, LoaderComponent: React.createElement(LoaderBase, { style: { height: 90 }, mh: theme.spacing.page, mv: theme.spacing.standard.sm }), ErrorComponent: React.createElement(GenericServerError, { error: queryState.error, onRetry: onRetry }), DataComponent: () => (React.createElement(Column, { role: "region", accessibilityLabel: questionString || 'Question' },
            !!questionString && (React.createElement(Typography, { role: "heading", "aria-level": 1, style: visuallyHidden }, questionString)),
            React.createElement(QuestionItem, { variant: "question-details", data: questionDetails }),
            React.createElement(ImproveQuestion, { onEdit: onEditPress }))) }));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default QuestionQueryHandler;
